import React, { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
const AddAppointment = lazy(() => import('./AddAppointment'))

const AppointmentRoutes: RouteObject[] = [
  { path: 'add-appointment', element: <AddAppointment mode="add"/> },
  { path: 'edit-appointment/:appointmentID', element: <AddAppointment mode="edit"/> },

]
export default AppointmentRoutes